import { render, staticRenderFns } from "./JourneyConnectionActions.vue?vue&type=template&id=0531e85f&scoped=true&"
import script from "./JourneyConnectionActions.vue?vue&type=script&lang=js&"
export * from "./JourneyConnectionActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0531e85f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0531e85f')) {
      api.createRecord('0531e85f', component.options)
    } else {
      api.reload('0531e85f', component.options)
    }
    module.hot.accept("./JourneyConnectionActions.vue?vue&type=template&id=0531e85f&scoped=true&", function () {
      api.rerender('0531e85f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyConnection/GeneralSettings/JourneyConnectionActions.vue"
export default component.exports